<template>
  <div class="model-wrap">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="500px"
      center
    >
      <div class="content">
        <div class="mr-15">车型:</div>
        <div style="flex: 1">
          <el-select v-model="vehicle_model_name" placeholder="请选择车型">
            <el-option
              :label="item.label"
              :value="item.value"
              v-for="(item, index) in typeList"
              :key="index"
            ></el-option>
          </el-select>
        </div>
      </div>
      <template #footer>
        <span slot="footer" class="dialog-footer">
          <el-button @click="onHandleClose">取消</el-button>
          <el-button
            type="primary"
            @click="onHandleSubmit"
            :loading="btnLoading"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  postLogisticsPremiumsVehicleModelChange,
  postLogisticsBasicFeeVehicleModelChange,
  postFleetCarVehicleModelMap,
} from "@/api/general/cost.js";

export default {
  name: "modify-vehicle-model",
  data() {
    return {
      dialogVisible: false,
      typeList: [],
      vehicle_model_name: "",
      id: "",
      btnLoading: false,
      dialogTitle: "",
      type: "", // 1-发车费用 2-保险费用
    };
  },
  methods: {
    // 获取车型下拉
    async postAjaxFleetCarVehicleModelMap() {
      try {
        const res = await postFleetCarVehicleModelMap({
          logistics_premiums_id: this.type != 1 ? this.id : "",
          logistics_fee_id: this.type == 1 ? this.id : "",
        });
        console.log(res, "res=");
        this.typeList = res.data || [];
      } catch (error) {
        console.log(error, "postFleetCarVehicleModelMap");
      }
    },
    async onHandleSubmit() {
      if (!this.vehicle_model_name) {
        this.$message.error("请选择车型");
        return;
      }
      this.btnLoading = true;
      // 城市仓发车费用
      if (this.type == 1) {
        try {
          const res = await postLogisticsBasicFeeVehicleModelChange({
            logistics_fee_id: this.id,
            vehicle_model_name: this.vehicle_model_name,
          });
          console.log(res, "res==");
          this.$message({
            type: "success",
            message: "修改车型成功",
          });
          this.dialogVisible = false;
          this.$emit("submit-form");
        } catch (error) {
          console.log(error, "postLogisticsPremiumsVehicleModelChange");
        } finally {
          this.btnLoading = false;
        }
      } else {
        // 城市仓保险费用
        try {
          const res = await postLogisticsPremiumsVehicleModelChange({
            logistics_premiums_id: this.id,
            vehicle_model_name: this.vehicle_model_name,
          });
          console.log(res, "res==");
          this.$message({
            type: "success",
            message: "修改车型成功",
          });
          this.dialogVisible = false;
          this.$emit("submit-form");
        } catch (error) {
          console.log(error, "postLogisticsPremiumsVehicleModelChange");
        } finally {
          this.btnLoading = false;
        }
      }
    },
    /**
     * 初始化
     */
    onInitData(data, val) {
      this.dialogVisible = true;
      this.vehicle_model_name = "";
      this.id = data.id;
      this.dialogTitle = data.logistics_name;
      this.type = val;
      this.postAjaxFleetCarVehicleModelMap();
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.model-wrap {
  .content {
    display: flex;
    align-items: center;
    // height: 500px;
    // border: 1px solid #ebeef5;
  }
}
.search-wrap {
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  margin-bottom: 10px;
  .form-item {
    display: flex;
    align-items: center;
    height: 40px;
    .value {
      width: 207px;
    }
  }
}
.pagination-wrap {
  box-sizing: border-box;
  padding: 10px 0;
}
</style>
